import { render, staticRenderFns } from "./hrefPage.vue?vue&type=template&id=78921955"
import script from "./hrefPage.vue?vue&type=script&lang=js"
export * from "./hrefPage.vue?vue&type=script&lang=js"
import style0 from "./hrefPage.vue?vue&type=style&index=0&id=78921955&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports